@if (isEditMode()) {
  <lib-patient-alerts-item-edit
    [patientAlertsItem]="patientAlertsItem()"
    [isEditMode]="isEditMode()"
    [isNewItem]="isNewItem()"
    [isLoading]="isLoading()"
    [deletePatientAlertEnabled]="deletePatientAlertEnabled()"
    (cancelButtonClicked)="setEditMode(false)"
    (cancelButtonClickedNewItem)="onDiscardNewItem()"
    (deleteButtonClicked)="onDeleteItem($event)"
    (saveButtonClicked)="onSaveItem($event)"
  ></lib-patient-alerts-item-edit>
} @else {
  <lib-patient-alerts-item-details
    [patientAlertsItem]="patientAlertsItem()"
    [editPatientAlertEnabled]="editPatientAlertEnabled()"
    (editButtonClicked)="setEditMode(true)"
  ></lib-patient-alerts-item-details>
}
